﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const components_1 = require("../../components");
const app_commons_1 = require("@its-suite/app-commons");
class ErrorPageForbidden extends React.Component {
    render() {
        let properties = {
            appName: process.env.APP_NAME,
            appVersion: process.env.APP_VERSION,
            menuOptions: null,
            appContent: (React.createElement("div", null,
                React.createElement(app_commons_1.ErrorPage, { buttonText: this.props.translate('GoToHomePage'), titleText: `${app_commons_1.Constants.EXCEPTIONS.forbiddenAccess.errorCode} ${this.props.translate(app_commons_1.Constants.EXCEPTIONS.forbiddenAccess.exceptionResourceKey)}`, subtitleText: this.props.translate('ErrorForbidden_Subtitle'), errorHintText: this.props.translate('ErrorPage_Hint'), redirectTo: app_commons_1.ApplicationRoutes.ROOT })))
        };
        return (React.createElement("div", null,
            React.createElement(components_1.AppBar, Object.assign({}, properties))));
    }
}
function mapStateToProps(state) {
    return { translate: state.translate };
}
exports.default = react_redux_1.connect(mapStateToProps)(ErrorPageForbidden);
//# sourceMappingURL=ErrorPageForbidden.js.map